<ng-container *ngIf="value">
    <div class="canvas title">{{ value.title }}</div>

    <canvas baseChart *ngIf="isData()" [data]="value.data" [labels]="value.labels" [options]="value.options"
        [legend]="value.legend" [chartType]="value.chartType" (chartClick)="onChartClick($event)"
        [colors]="value.backgroundColor"></canvas>

    <canvas baseChart *ngIf="isDataSets()" [datasets]="value.datasets" [labels]="value.labels" [options]="value.options"
        [legend]="value.legend" [chartType]="value.chartType" (chartClick)="onChartClick($event)"></canvas>

    <div class="selected-label" [ngClass]="{ show: showSelectedLabel }">
        {{ selectedlabel }}
    </div>
</ng-container>